import { HideIcon, ShowIcon } from "../../Icons";

const PasswordToggleIcon = ({ isVisible, onToggle, className = "p-2 hover:bg-option-hover rounded-full" }) => {
  return isVisible ? (
    <ShowIcon
      className={className}
      onClick={onToggle}
    />
  ) : (
    <HideIcon
      className={className}
      onClick={onToggle}
    />
  );
};

export default PasswordToggleIcon;
